import styled, { css } from 'styled-components';

export default styled.section`
  display: flex;
  flex-direction: column;
  padding-bottom: 170px;

  ${({ $background }) =>
    $background &&
    css`
      background: ${$background};
    `}

  > .center {
    padding: 120px 3% 60px 3%;
  }
`;
